import AdminLayout from '../layouts/Admin';
import AdminDashboard from '../components/Admin';

export default function AdminDashboardPage() {
  return (
    <AdminLayout>
      <AdminDashboard />
    </AdminLayout>
  );
}
